import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, from, Subject } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';


import { NotificationsContextEnum } from '@core/store/models/notifications.enum';
// services
import { NotificationsService } from '@core/services/notifications/notifications.service';

import * as fromStore from './recorder.state';
import * as fromActions from './recorder.actions';
import { Record } from '@core/store/models/recorder.class';

@Injectable()
export class RecorderEffects {


    public readonly TYPES = NotificationsContextEnum;
    public readonly VIDEO_FILE_MIME_TYPE_CODECS = 'video/webm; codecs="vp8, opus"';
    constructor(private actions$: Actions,private store$: Store<fromStore.Recorder>, private notifSrv: NotificationsService) {}

    public init$ = createEffect(() => this.actions$.pipe(
      ofType<fromActions.Init>(fromActions.RecorderActionType.Init),
      switchMap((action) => {
        // console.log(" ##### EFFECT inittt$ action ",action)
        let record = new Record(action.config,action.data);
        // prepare the streams inside the record class
        return from(record.prepareRecord()).pipe(
          map(() => {
            // let streams = record.streams; // just to check them
            return new fromActions.Start(record);
          }),
          catchError(error => of(new fromActions.StartFail(error, record)))
        );
      })

    ));
    
    public starts$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.Start>(fromActions.RecorderActionType.Start),
        switchMap((action) => {
          let effectEvents: Array<any> = [];
          // call stop for all streams we have.
          const combinedStream = action.record.getCombinedStreams();

          const mediaRecorder = new MediaRecorder(combinedStream, {mimeType : this.VIDEO_FILE_MIME_TYPE_CODECS});
          mediaRecorder.start(1000);
          // launch the notification record.
          this.notifSrv.addNotification(this.TYPES.ACTION_RECORD_START ,action.record.data)
          effectEvents.push(new fromActions.StartSuccess(action.record,mediaRecorder));
          return effectEvents;
        })
  
    ));

    // start success effect accumulate chunks of the video inside the store to keep 
    // them in order to get file video to preview adn then save.
    public startSuccess$ = createEffect(() => this.actions$.pipe(
      ofType<fromActions.StartSuccess>(fromActions.RecorderActionType.StartSuccess),
      withLatestFrom(this.store$.select(fromStore.recorderSelector)),
      mergeMap(([action, storeRecorder]) => {
        const subject = new Subject<fromActions.StoreStreamChunk>();
        // listen the mediaRecorder data to store on the chunks
        if(storeRecorder.mediaRecorder){
          storeRecorder.mediaRecorder.ondataavailable = (event) => {
            // console.log(" StartSuccess MediaRecorder ondataavailable =======> ", event.data);
            subject.next(new fromActions.StoreStreamChunk(event.data));
          };
        }
        return subject.asObservable();
      })
    ));
  

    public startsFail$ = createEffect(() => this.actions$.pipe(
      ofType<fromActions.StartFail>(fromActions.RecorderActionType.StartFail),
      withLatestFrom(this.store$.select(fromStore.recorderSelector)),
      switchMap(([action,storeRecorder]) => {
        if(storeRecorder.mediaRecorder){
          storeRecorder.mediaRecorder.stop();
        }
        if(storeRecorder.recordData){
          // Stop the recording streams as well when fail
          storeRecorder.recordData.stopStreams();
        };
        // UNDER TESTING: launch the notification for record fail. GENERIC EVENT_FAILED NOTIFICATION
        let details = {
          title: "Recording Process",
          message:"There was some issues recording the message. Try again with different options or configuration."};
        this.notifSrv.addNotification(this.TYPES.EVENT_FAILED ,{ id:action.record.id, details: details});
        // trigger Clear
        return [new fromActions.Clear()]
      })

    ));

    public stop$ = createEffect(() => this.actions$.pipe(
      ofType<fromActions.Stop>(fromActions.RecorderActionType.Stop),
       withLatestFrom(this.store$.select(fromStore.recorderSelector)),
       switchMap(([action, storeRecorder]) => {
        // console.log(" ###### EFFECT Stop$ action ",action)
          let effectSuccessEvents: Array<any> = [];
          // Stop the recording streams
          storeRecorder.recordData.stopStreams();
          // stop the media recorder and set data to the video file
          if(storeRecorder.mediaRecorder){
            storeRecorder.mediaRecorder.stop()
          };
          // console.log(" mediaRecorder stoppeddddd ",storeRecorder.mediaRecorder);
          return effectSuccessEvents;
      })
    ));

    // // Think we don't need this
    // public clear$ = createEffect(() => this.actions$.pipe(
    //   ofType<fromActions.Clear>(fromActions.RecorderActionType.Clear),
    //    withLatestFrom(this.store$.select(fromStore.recorderSelector)),
    //    switchMap(([action, storeRecorder]) => {
    //       let effectSuccessEvents: Array<any> = [];
    //       // stop the media recorder and set data to the video file
    //       if(storeRecorder.recordData){
    //         // Stop the recording streams
    //         storeRecorder.recordData.stopStreams();
    //       };
    //       return effectSuccessEvents;
    //   })
    // ));

}
